import { StringUtils } from "Global/Base/Utils/StringUtils";
import { AttrValueReader } from "OW.Remoting/Remoting/AttrValueReader";
import { OWObject } from "OW.Remoting/Remoting/DataTypes/OWObject";
import { Control } from "./Control";
import { ControlParams, IRequiresActualObject } from "./ControlInterfaces";

export class ControlWithBackground extends Control implements IRequiresActualObject {
    private _actualObject: OWObject | null = null;
    private _backgroundAttrName: string;
    private _backgroundColor: string;

    public get actualObject(): OWObject | null {
        return this._actualObject;
    }

    public set actualObject(value: OWObject | null) {
        this._setActualObject(value);
    }

    /**
     * Barva pozadí získaná z hodnoty atributu určujícího obarvení (BackgroundAttr).
     */
    public get backgroundColor(): string {
        return this._backgroundColor;
    }

    public set backgroundColor(value: string) {
        this.element.dataset.color = value;
        this._backgroundColor = value;
    }

    /**
     * Název atributu, který určuje barvu pozadí.
     */
    public get backgroundAttrName(): string {
        return this._backgroundAttrName;
    }

    constructor(params: ControlParams) {
        super(params);

        this._backgroundAttrName = this.getDataAttr("backgroundattr");
        if (this._backgroundAttrName) {
            this.element.classList.add("backgroundAttrColor");
        }
    }

    protected async _setBackgroundColor(): Promise<void> {
        if (this._actualObject) {
            const backgroundAttrValue = await this._actualObject.getValue(this._backgroundAttrName);
            this.backgroundColor = AttrValueReader.read(backgroundAttrValue);
        } else {
            this.backgroundColor = "fNone";
        }
    }

    protected async _setActualObject(value: OWObject | null): Promise<void> {
        if (value === this._actualObject) {
            return;
        }

        if (this._actualObject) {
            this._actualObject.attributeChanged.remove(this._attributeChangedEventMethod);
        }

        this._actualObject = value ?? null;

        if (this._actualObject) {
            this._actualObject.attributeChanged.add(this._attributeChangedEventMethod);
        }

        if (this._backgroundAttrName) {
            this._setBackgroundColor();
        }
    }

    protected _attributeChangedEventMethod = (_sender: OWObject, attributeName: string) => {
        if (StringUtils.compareCaseInsensitive(attributeName, this._backgroundAttrName)) {
            this._setBackgroundColor();
        }
    };

    public override dispose(): void {
        if (this._actualObject) {
            this._actualObject.attributeChanged.remove(this._attributeChangedEventMethod);
        }
        super.dispose();
    }
}
